import { render, staticRenderFns } from "./ProfileHealthInsurance.vue?vue&type=template&id=73837e1d&"
import script from "./ProfileHealthInsurance.vue?vue&type=script&lang=js&"
export * from "./ProfileHealthInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports